import SocialMediaLink from "./SocialMediaLink.tsx";
import { useEmailShareUrl, useFacebookShareUrl, useTwitterShareUrl } from "./useSharing.ts";

export const SocialMediaGroup = () => {
  const emailLink = useEmailShareUrl();
  const fbLink = useFacebookShareUrl();
  const twitterLink = useTwitterShareUrl();

  return (
    <div className="flex py-8 mt-4">
      {emailLink && <SocialMediaLink type="mail" title={emailLink.title} url={emailLink.url} />}
      {fbLink && <SocialMediaLink type="facebook" title={fbLink.title} url={fbLink.url} />}
      {twitterLink && <SocialMediaLink type="twitter" title={twitterLink.title} url={twitterLink.url} />}
    </div>
  );
};
